import { Link } from 'react-router-dom';
import { categories, allArticles } from '@/mocks/articles';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

function getBreadcrumbs(): BreadcrumbItem[] {
  const path = window.location.pathname;
  const items: BreadcrumbItem[] = [{ label: '首页', href: '/' }];

  if (path.startsWith('/category/')) {
    const slug = path.split('/category/')[1];
    const cat = categories.find((c) => c.slug === slug);
    if (cat) {
      items.push({ label: cat.name, href: `/category/${slug}` });
    }
  }

  if (path.startsWith('/article/')) {
    const slug = path.split('/article/')[1];
    const article = allArticles.find((a) => a.slug === slug);
    if (article) {
      const cat = categories.find((c) => c.slug === article.category);
      if (cat) {
        items.push({ label: cat.name, href: `/category/${cat.slug}` });
      }
      items.push({ label: article.title });
    }
  }

  if (path === '/about') {
    items.push({ label: '关于我们' });
  }

  return items;
}

export default function Breadcrumb() {
  const items = getBreadcrumbs();

  if (items.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="w-full max-w-7xl mx-auto px-4 md:px-6 pt-20 pb-4">
      <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="hover:text-primary-600 transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}